/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterObject extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterObject");
    }

    getFixupPrototypeFunction() { return ParameterObject.fixupPrototype; }

    static newInstance(model: Partial<ParameterObject>): ParameterObject {
        let obj = Object.assign(new ParameterObject(), model);
        ParameterObject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterObject>): ParameterObject {
        if (!model) return null;
        return ParameterObject.newInstance(<ParameterObject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterObject) {
        if (!obj) return;

        models.ParameterObject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterObject): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterObject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.properties) {
            for (let val of this.properties) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    properties: Array<models.NamedParameter>;

}
